export const InputVinStateEnum = {
  LENGTH_NOT_MATCH: "LENGTH_NOT_MATCH",
  INVALID_CHARACTER: "INVALID_CHARACTER",
  VALID: "VALID",
  EMPTY: "EMPTY",
};

/**
 * Checks the validity of the entered VIN
 * @param {string} vin
 * @returns {InputVinStateEnum}
 */

export const checkVin = (vin) => {
  const validCharactersOnlyRegex = /[^a-zA-z0-9]/;
  if (validCharactersOnlyRegex.test(vin))
    return InputVinStateEnum.INVALID_CHARACTER;
  if (vin.length === 0) return InputVinStateEnum.EMPTY;
  if (vin.length !== 17) return InputVinStateEnum.LENGTH_NOT_MATCH;
  return InputVinStateEnum.VALID;
};
